import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { LOSTCARGO } from '../lostCargo.classes';

type LostCargoNotFoundPanelProps = {
    notFoundShipments: string[];
};

export const LostCargoNotFoundPanel = ({ notFoundShipments }: LostCargoNotFoundPanelProps) => {
    const { t } = useTranslation();

    if (notFoundShipments.length === 0) {
        return null;
    }

    return (
        <Box
            className={LOSTCARGO.notFoundPanel}
            sx={{
                backgroundColor: '#fdecea',
                border: '1px solid #d32f2f',
                borderRadius: '4px',
                padding: '12px 16px',
                marginBottom: '16px',
                color: '#d32f2f',
            }}
        >
            <p className={LOSTCARGO.notFoundTitle} style={{ fontWeight: 700, marginBottom: '4px' }}>
                {t('lostCargo.notFoundCount', { count: notFoundShipments.length })}
            </p>
            <p className={LOSTCARGO.notFoundHint} style={{ fontSize: '13px', marginBottom: '8px' }}>
                {t('lostCargo.notFoundHint')}
            </p>
            <Box
                className={LOSTCARGO.notFoundList}
                component="ul"
                sx={{
                    fontSize: '13px',
                    fontFamily: 'monospace',
                    margin: 0,
                    paddingLeft: '20px',
                    maxHeight: '180px',
                    overflowY: 'auto',
                    listStyleType: 'decimal',
                }}
            >
                {notFoundShipments.map((number) => (
                    <li key={number} style={{ wordBreak: 'break-all', padding: '1px 0' }}>
                        {number}
                    </li>
                ))}
            </Box>
        </Box>
    );
};
